<template>
  <div class="master-filter search-filter">
    <label class="search-label">
      <span class="dropdown-title">Klient</span>
      <span class="search-field">
        <svg
          class="search-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="2"/>
          <path d="M16 16L21 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <input
          class="search-field-input"
          v-model="query"
          type="search"
          autocomplete="off"
          placeholder="Meno alebo telefón"
          aria-label="Hľadať klienta podľa mena alebo telefónu"
          @input="scheduleFilter"
          @keyup.enter="emitFilter"
        />
        <button
          v-if="query"
          type="button"
          class="search-clear"
          aria-label="Vymazať vyhľadávanie"
          @click="reset"
        >
          ×
        </button>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "SearchByKey",
  data: () => ({
    query: "",
    debounceTimer: null,
  }),
  beforeDestroy() {
    window.clearTimeout(this.debounceTimer);
  },
  methods: {
    scheduleFilter() {
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(this.emitFilter, 350);
    },
    emitFilter() {
      window.clearTimeout(this.debounceTimer);
      this.$emit("filter-client-by-key", this.query.trim());
    },
    reset() {
      window.clearTimeout(this.debounceTimer);
      this.query = "";
      this.$emit("filter-client-by-key", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-filter {
  min-width: 280px;
}

.search-label {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
}

.dropdown-title {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.search-field {
  display: flex;
  width: min(280px, 28vw);
  min-width: 210px;
  height: 42px;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, .28);
  border-radius: 12px;
  background: rgba(8, 27, 76, .2);
  color: rgba(255, 255, 255, .82);
  transition: border-color .18s ease, background .18s ease, box-shadow .18s ease;
}

.search-field:focus-within {
  border-color: rgba(255, 255, 255, .78);
  background: rgba(8, 27, 76, .34);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, .1);
}

.search-icon {
  flex: 0 0 auto;
}

.search-field input.search-field-input {
  height: 100%;
  padding: 0;
  width: 100%;
  min-width: 0;
  border: 0 !important;
  border-radius: 0;
  outline: 0;
  background: transparent !important;
  box-shadow: none !important;
  color: #fff !important;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  -webkit-appearance: none;
  appearance: none;
}

.search-field input.search-field-input::placeholder {
  color: rgba(255, 255, 255, .64) !important;
  font-weight: 500;
  opacity: 1;
}

.search-field input.search-field-input::-webkit-search-cancel-button {
  display: none;
}

.search-clear {
  display: grid;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, .14);
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.search-clear:hover {
  background: rgba(255, 255, 255, .24);
}

@media (max-width: 767px) {
  .search-filter,
  .search-label,
  .search-field {
    width: 100%;
    min-width: 0;
  }

  .search-label {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }
}
</style>
